import { render, staticRenderFns } from "./index.voyage.vue?vue&type=template&id=375a66b2"
import script from "./index.voyage.vue?vue&type=script&lang=js"
export * from "./index.voyage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports